import api from "./api/api";

const ConfigDesks = {
  getAllColaboradores: async () => {
    try {
      const res = await api.get(`/users`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getUserById: async (id: number) => {
    try {
      const res = await api.get(`/users/${id}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getAllContatosPagination: async (page: any, perPage: any) => {
    try {
      const res = await api.get(`/users?page=${page}&perPage=${perPage}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getAllTimeAgencyDesk: async (agency_id: any) => {
    try {
      const res = await api.get(
        `/users?page=1&perPage=100&type=2&agencia_id=${agency_id}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getContatosBusca: async (
    page: any,
    perPage: any,
    busca?: any,
    typeUser?: any,
    agency_id?: any,
    cargo_i?: any,
    area_id?: any,
    regiao_id?: any,
    representante_id?: any,
    representado_id?: any,
    cliente_id?: any,
    is_admin?: any,
    is_user?: boolean,
    is_new?: boolean,
    is_ad_link?: boolean,
    is_verified?: boolean,
  ) => {
    try {
      const params = new URLSearchParams();

      params.append("page", page);
      params.append("perPage", perPage);
      if (busca) params.append("s", busca);
      if (typeUser) params.append("type", typeUser);
      if (agency_id) params.append("agencia_id", agency_id);
      if (cargo_i) params.append("cargo_id", cargo_i);
      if (area_id) params.append("area_id", area_id);
      if (regiao_id) params.append("uf_id", regiao_id);
      if (representante_id) params.append("representante_id", representante_id);
      if (representado_id) params.append("representado_id", representado_id);
      if (cliente_id) params.append("cliente_id", cliente_id);
      if (is_admin !== undefined) params.append("is_admin", String(is_admin));
      if (is_user !== undefined) params.append("is_user", String(is_user));
      if (is_new !== undefined) params.append("is_new", String(is_new));
      if (is_ad_link !== undefined)
        params.append("is_ad_link", String(is_ad_link));
      if (is_verified !== undefined)
        params.append("is_verified", String(is_verified));

      const res = await api.get(`/users?${params.toString()}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTypeStatusDesk: async () => {
    try {
      const res = await api.get(`/desks/types_status`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTypesDesks: async () => {
    try {
      const res = await api.get("/types-desks");
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  createTypeDesk: async (payload: { name: string }) => {
    try {
      const res = await api.post("/types-desks", payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getTypesDesksByJornada: async (jornadaId: number | string) => {
    try {
      const res = await api.get(`/types-desks?jornada_id=${jornadaId}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  updateTypeDesk: async (
    typeDeskId: number | string,
    payload: {
      name: string;
      active?: boolean;
      jornada_id?: number | string;
    },
  ) => {
    try {
      const res = await api.put(`/types-desks/${typeDeskId}`, payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  syncTypeDeskJourneys: async (payload: {
    id_projeto: number;
    ids_jornadas: number[];
  }) => {
    try {
      const res = await api.post("/types-desks/sync-jornadas", payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getVeiculosDesk: async () => {
    try {
      const res = await api.get(`/desks/produtos/veiculos`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getCanaisDesk: async (id_veiculo: any) => {
    try {
      const res = await api.get(`/desks/produtos/canais/${id_veiculo}`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getFormatosDesk: async (id_veiculo: any, id_canal: number) => {
    try {
      const res = await api.get(
        `/desks/produtos/canais/${id_veiculo}/formatos/${id_canal}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getModelosDesk: async (
    id_veiculo: any,
    id_canal: number,
    id_formato: number,
  ) => {
    try {
      const res = await api.get(
        `/desks/produtos/canais/${id_veiculo}/formatos/${id_canal}/modelos/${id_formato}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getPrecoDesk: async (
    id_veiculo: number,
    id_canal: number,
    id_formato: number,
    id_modelo: number,
  ) => {
    try {
      const res = await api.get(
        `/desks/getProduto/${id_veiculo}/${id_canal}/${id_formato}/${id_modelo}`,
      );
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getPrecoDescontoDesk: async (payload: any) => {
    try {
      const res = await api.post("/desks/getProduto", payload);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getFunilBriefing: async () => {
    try {
      const res = await api.get(`/desks/produtos/funil`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getRelationsShips: async (userId: any) => {
    try {
      const res = await api.get(`/users/${userId}/relationships`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getCustoPlataformaStatus: async () => {
    try {
      const res = await api.get(`/custo-plataforma-status`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default ConfigDesks;
